import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Renders a protected image by fetching as blob (cookies included).
export function AuthImage({ path, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let revoke;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setSrc(url);
      } catch (_e) {
        setSrc(null);
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);
  if (!src) {
    return <div className={`bg-muted animate-pulse ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
